import React, { FunctionComponent, useEffect, useMemo } from 'react';
import { observer, Observer } from 'mobx-react';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { Container } from '../../../libs/base/base-style';
import { useHorsesStore } from '../../../stores/horses'
import { useHistory } from 'react-router-dom';
import { IconButton } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Grid from '@mui/material/Unstable_Grid2';
import OrderDailog from './OrderDialog'
import { styled } from '@mui/material/styles';

const GridContainer = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',

    },
}));
const FullWidthContainer = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',

    },
}));
const App: FunctionComponent = (props) => {
    const stores = useHorsesStore()

    return <Observer>{() => <Wrapper>
        <GridContainer container spacing={2} >

            {stores.horses && stores.horses.map((item, index) => {

                return item._ID && <FullWidthContainer><Horse name={item.show_name ? item.show_name : 'Unnamed'} description={item.notes} pic={item.avatar} id={item._ID} /> </FullWidthContainer>
            })}

            <FullWidthContainer >
                <Add />
            </FullWidthContainer>

        </GridContainer>

    </Wrapper>}</Observer>
}


const horseStyle = {

    width: 245,
    minHeight: 390,
    display: 'flex',
    flexDirection: 'column'
}

const CardContainer = styled(Card)(({ theme }) => ({
    width: 245,
    minHeight: 390,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
        width: '100%'
    },
}));

const Horse: FunctionComponent<{ name: string; pic: string; description: string; id: string }> = (props) => {
    const route = useHistory()
    const [open, setOpen] = React.useState(false);
    const stores = useHorsesStore()
    const onBtnView = () => {
        if (stores.checkExpire(props.id)) {
            route.push('details', { id: props.id })
        } else {
            setOpen(true)
        }

    }
    const onSelectOrder = (id: number) => {
        route.push('details', { id: props.id })
    }

    const onBtnDelete = () => {
        stores.deleteProfile(props.id)
    }

    return <CardContainer>
        <CardMedia
            sx={{ height: 140 }}
            image={props.pic}
            title="green iguana"
        />
        <CardContent>
            <Typography gutterBottom variant="h4" component="div" color="#408697">
                {props.name}
            </Typography>
            <Typography gutterBottom variant="h5" component="div" color="#408697">
                Description
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {props.description}
            </Typography>
        </CardContent>
        <CardActions sx={{ mt: "auto" }}>
            <Button variant='contained' fullWidth sx={{ padding: '0 !important', backgroundColor: 'initial !important', height: '25px', color: '#fff !important', background: ' #408697 !important', fontSize: '10px !important', borderRadius: 0 }} onClick={onBtnView}>View</Button>
            <Button variant='outlined' fullWidth sx={{ padding: '0 !important', backgroundColor: 'initial !important', color: ' #408697 !important', height: '25px', fontSize: '10px !important', borderRadius: 0, borderColor: '#408697 !important' }} onClick={onBtnDelete}>Delete</Button>
        </CardActions>
        <OrderDailog open={open} onClose={() => setOpen(false)} onSelect={onSelectOrder} profileId={props.id} />
    </CardContainer>
}

const Add = () => {
    const [open, setOpen] = React.useState(false);
    const route = useHistory()
    const store = useHorsesStore()
    const onBtnAdd = () => {
        setOpen(true)
    }

    const onSelectOrder = (id: number) => {
        route.push('details')
    }

    useEffect(() => {
        console.log(store.orders)
    }, [open])
    return <Observer>{() => <CardContainer >
        <CardActions sx={{ justifyContent: 'center', width: '100%', flexDirection: 'column', flex: 1 }}>
            <IconButton color="primary" aria-label="upload picture" component="label" sx={{ justifyContent: 'center' }} onClick={onBtnAdd}>
                <AddCircleOutlineIcon sx={{ fontSize: '50px', color: '#408697' }} />

            </IconButton>
            <Typography variant="h4" color="#408697">
                Add a Horse
            </Typography>
        </CardActions>
        <OrderDailog open={open} onClose={() => setOpen(false)} onSelect={onSelectOrder} />
    </CardContainer >}</Observer>
}
const Wrapper = styled(Container)`
    padding:20px;
    display:flex;
    flex:1;
    flexDirection:column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height:600px;
    width:100%;
    height:100%;

`


export default observer(App)